<div style="margin-top:5%">
  <h2 class="text-center">File A Claim</h2>
  <br />
  <br />
  <div class="row">
    <div class="col-md-1">
    </div>
    <div class="col-md-5">
      <div class="card card-default">
        <div class="card-body text-center no-padding">
          <p style="font-weight:bold; font-size:1.4em">File Consumer Claim</p>
          <p>Select this option to file on behalf of yourself.</p>

          <p>
            This form is to be filled out by the individual who paid for the drug.
          </p>


          <div class="row text-center">
            <div class="col-md-12">
              <button class="btn btn-primary" [routerLink]='["/consumer-instructions"]' type="button">File Consumer Claim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div class="card card-default">
        <div class="card-body text-center no-padding">
          <p style="font-weight:bold; font-size:1.4em">File TPP Claim</p>
          <p>Select this option to file a third-party payor claim</p>
          <p>This form is to be filled out on behalf of a third-party payer, not individual consumers.</p>
          <div class="row text-center">
            <div class="col-md-12">
              <button class="btn btn-primary" [routerLink]='["/tpp-instructions"]' type="button">File TPP Claim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-1">
    </div>
  </div>
</div>





<!--<div class="container">
  <footer style="margin:0 auto; text-align: center; margin-top:3%">
    <p style="text-align: justify; text-justify: auto; font-size: 1.0em;">
      By providing your information, either on paper, electronically, or through a website, you consent to us storing and using your
      information for case administration purposes only. Our site uses tracking technologies to tailor your experience and understand
      how you and other visitors use our site. By continuing to navigate this site you consent to use of these tracking technologies.
      For more information on how we use your personal data, please read our <a style="color:#0066cb" href="https://abdatacaadstorage1.blob.core.windows.net/privacy/PrivacyPolicy.pdf"
                                                                                target="_blank">Privacy Policy</a>.
    </p>
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6 text-center">
        <img src="./assets/ABdata_logo_highres_ small_Again.png" class="img-responsive pull-left app-fixed-image"/><br />
        <p style="font-size:1.0em">&copy; 2026 - QVAR Antitrust Settlement All rights reserved.</p>
      </div>
      <div class="col-md-3"></div>
    </div>
    <br />
  </footer>
</div>-->
